(() => {
  'use strict';
  const panel = document.getElementById('bfg-snow-preview');
  const summary = document.getElementById('shopify-section-pr_summary');
  if (!panel || !summary) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  const root = document.documentElement;
  const closeButton = panel.querySelector('[data-bfg-snow-close]');
  const hint = panel.querySelector('[data-bfg-snow-hint]');
  const viewport = window.visualViewport;
  let open = false;
  let savedY = 0;
  let launcher = null;
  let frame = 0;
  let gallery = null;
  let pendingStart = null;
  let wasCropping = false;
  const photoRetries = new WeakMap();
  const photoTimers = new Set();
  const initialHint = hint.textContent;
  const form = () => document.getElementById('tee-artwork-form');
  function photos() {
    return Array.from(document.querySelectorAll('#teeFormInputs img.tee-photo-image'));
  }
  function retryPhoto(image) {
    if (!image.complete || image.naturalWidth || !image.src.startsWith('https://')) return;
    let retry = photoRetries.get(image);
    if (!retry || (image.src !== retry.original && !retry.urls.has(image.src))) {
      retry = { original: image.src, attempts: 0, urls: new Set(), timer: null };
      photoRetries.set(image, retry);
    }
    if (retry.timer || retry.attempts >= 2) return;
    retry.timer = window.setTimeout(() => {
      photoTimers.delete(retry.timer);
      retry.timer = null;
      if (!image.isConnected || image.naturalWidth || (image.src !== retry.original && !retry.urls.has(image.src))) return;
      const url = new URL(retry.original);
      url.searchParams.set('bfg_photo_retry', String(++retry.attempts));
      retry.urls.add(url.href);
      image.src = url.href;
    }, retry.attempts ? 1500 : 500);
    photoTimers.add(retry.timer);
  }
  document.addEventListener('error', event => {
    if (event.target.matches?.('#teeFormInputs img.tee-photo-image')) {
      retryPhoto(event.target);
      schedule();
    }
  }, true);
  document.addEventListener('load', event => {
    if (!event.target.matches?.('#teeFormInputs img.tee-photo-image')) return;
    const image = event.target;
    const retry = photoRetries.get(image);
    if (retry && retry.urls.has(image.src) && image.naturalWidth) {
      document.querySelectorAll('#teeinblue-wrapper svg image').forEach(layer => {
        const href = layer.getAttribute('href') || layer.getAttribute('xlink:href');
        if (href === retry.original || retry.urls.has(href)) {
          if (layer.hasAttribute('href')) layer.setAttribute('href', image.src);
          else layer.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', image.src);
        }
      });
    }
    syncPreview();
  }, true);
  function cropDialogVisible() {
    const dialog = document.querySelector('.tee-dialog-image-cropper .vm--modal');
    return Boolean(dialog && dialog.getClientRects().length && getComputedStyle(dialog).visibility !== 'hidden');
  }
  function fullPreviewVisible() {
    const dialog = document.querySelector('.tee-dialog-gallery .vm--modal');
    return Boolean(dialog && dialog.getClientRects().length && getComputedStyle(dialog).visibility !== 'hidden');
  }
  function artworkReady() {
    const artwork = document.querySelector('#tee-gallery .tee-printarea-artwork');
    return Boolean(artwork && artwork.getClientRects().length);
  }
  function keepFieldVisible() {
    const currentForm = form();
    const field = document.activeElement;
    if (!currentForm || !currentForm.contains(field) || !field.matches('input,textarea,select')) return;
    const bounds = currentForm.getBoundingClientRect();
    const fieldBounds = field.getBoundingClientRect();
    const bottom = bounds.bottom - Math.min(130, bounds.height * 0.3);
    if (fieldBounds.bottom > bottom) currentForm.scrollTop += fieldBounds.bottom - bottom + 12;
    else if (fieldBounds.top < bounds.top + 12) currentForm.scrollTop -= bounds.top + 12 - fieldBounds.top;
  }
  function layout() {
    frame = 0;
    if (!open || cropDialogVisible()) return;
    const height = Math.round(viewport ? viewport.height : window.innerHeight);
    const top = Math.round(viewport ? viewport.offsetTop : 0);
    const previewHeight = Math.round(Math.max(115, Math.min(290, height * 0.33)));
    root.style.setProperty('--bfg-snow-top', top + 'px');
    root.style.setProperty('--bfg-snow-height', height + 'px');
    root.style.setProperty('--bfg-snow-preview-height', previewHeight + 'px');
    const nextGallery = document.getElementById('tee-gallery');
    if (nextGallery !== gallery) {
      gallery = nextGallery;
      resize.disconnect();
      const slider = gallery && gallery.querySelector('.tee-slider');
      if (slider) resize.observe(slider);
    }
    const slider = gallery && gallery.querySelector('.tee-slider');
    if (slider) {
      const scale = Math.min(1, (previewHeight - 56) / Math.max(slider.offsetHeight, 1), (window.innerWidth - 24) / Math.max(slider.offsetWidth, 1));
      root.style.setProperty('--bfg-snow-scale', String(scale));
    }
    const pendingPhotos = photos().filter(image => !image.complete || !image.naturalWidth);
    const failed = pendingPhotos.some(image => image.complete && !image.naturalWidth && (photoRetries.get(image)?.attempts || 0) >= 2);
    const text = pendingPhotos.length ? (failed ? hint.dataset.photoError : hint.dataset.photoLoading) : initialHint;
    if (hint.textContent !== text) hint.textContent = text;
    hint.hidden = !pendingPhotos.length && Boolean(gallery && gallery.querySelector('.tee-printarea-artwork'));
    keepFieldVisible();
  }
  function schedule() {
    if (open && !frame) frame = window.requestAnimationFrame(layout);
  }
  const resize = new ResizeObserver(schedule);
  function start(source) {
    if (!mobile.matches || !form() || open || cropDialogVisible() || fullPreviewVisible() || !artworkReady()) return;
    pendingStart = null;
    open = true;
    savedY = window.scrollY;
    launcher = source;
    root.style.setProperty('--bfg-snow-page-top', -savedY + 'px');
    document.body.classList.add('bfg-snow-editing');
    panel.hidden = false;
    layout();
  }
  function stop(restoreFocus = true) {
    pendingStart = null;
    if (!open) return;
    open = false;
    if (frame) window.cancelAnimationFrame(frame);
    frame = 0;
    resize.disconnect();
    gallery = null;
    panel.hidden = true;
    document.body.classList.remove('bfg-snow-editing', 'bfg-snow-cropping');
    window.scrollTo({ top: savedY, behavior: 'instant' });
    if (restoreFocus) {
      const target = launcher?.matches('button,[data-bfg-personalize-trigger]') && launcher.isConnected
        ? launcher : form()?.querySelector('.tee-btn--preview');
      target?.focus({ preventScroll: true });
    }
  }
  document.addEventListener('click', event => {
    if (!mobile.matches) return;
    if (event.target.closest('[data-bfg-personalize-trigger]')) {
      stop(false);
      // The existing mobile action bar scrolls to the options without opening a preview.
      return;
    }
    // Let TeeInBlue validate fields and open its completed preview without interception.
    if (event.target.closest('#tee-artwork-form .tee-btn--preview')) {
      pendingStart = null;
      return;
    }
    const option = event.target.closest('#teeFormInputs label');
    if (option && !open && !fullPreviewVisible()) {
      pendingStart = option;
      window.requestAnimationFrame(syncPreview);
    }
    schedule();
  }, true);
  document.addEventListener('focusin', event => {
    if (event.target.matches('#tee-artwork-form input[type=text],#tee-artwork-form textarea,#tee-artwork-form select')) {
      schedule();
    }
  });
  document.addEventListener('input', event => {
    if (!mobile.matches || open || fullPreviewVisible()) return;
    if (event.target.matches('#teeFormInputs input[type=text],#teeFormInputs textarea') && event.target.value.trim()) {
      pendingStart = event.target;
      syncPreview();
    }
  }, true);
  document.addEventListener('change', event => {
    if (!mobile.matches || open || fullPreviewVisible()) return;
    if (event.target.matches('#teeFormInputs input,#teeFormInputs textarea,#teeFormInputs select')) {
      pendingStart = event.target;
      window.requestAnimationFrame(syncPreview);
    }
  }, true);
  closeButton.addEventListener('click', () => stop());
  document.addEventListener('keydown', event => {
    if (!open || !mobile.matches || cropDialogVisible()) return;
    const currentForm = form();
    if (!panel.contains(event.target) && !currentForm?.contains(event.target)) return;
    if (event.key === 'Escape') { event.preventDefault(); stop(); }
    if (event.key !== 'Tab' || !currentForm) return;
    const controls = [closeButton, ...currentForm.querySelectorAll('button,input,select,textarea,a[href],[tabindex="0"]')].filter(node => !node.disabled && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function syncPreview() {
    photos().forEach(retryPhoto);
    const cropping = cropDialogVisible();
    document.body.classList.toggle('bfg-snow-cropping', open && cropping);
    if (cropping) { wasCropping = true; return; }
    if (wasCropping) {
      wasCropping = false;
      if (!open && photos().length) pendingStart = form()?.querySelector('.tee-photo-image');
    }
    if (fullPreviewVisible()) {
      // Close only after a successful native preview; invalid fields stay available for correction.
      stop(false);
      return;
    }
    // Some campaigns replace their input nodes while generating the first artwork.
    if (pendingStart) start(pendingStart.isConnected ? pendingStart : form()?.querySelector('.tee-btn--preview'));
    schedule();
  }
  // Native artwork and the completed preview are mounted outside the product summary.
  new MutationObserver(syncPreview).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'href', 'xlink:href'] });
  const cartDrawer = document.getElementById('nt_cart_canvas');
  if (cartDrawer) new MutationObserver(() => {
    if (open && cartDrawer.classList.contains('act_opened')) stop(false);
  }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  viewport?.addEventListener('resize', schedule);
  viewport?.addEventListener('scroll', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('pagehide', () => {
    photoTimers.forEach(timer => window.clearTimeout(timer));
    photoTimers.clear();
    stop(false);
  });
  mobile.addEventListener('change', () => { if (!mobile.matches) stop(false); });
})();
